import { Modal } from 'antd'
import styled from 'styled-components'

export const ModalCopiaAnalises = styled(Modal)`
  .ant-modal-content {
    padding: 0;
  }

  .titulo__modal {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 10px;
  }

  .body__modal {
    width: 100%;
    display: flex;
    flex-direction: column;
    padding: 10px;
  }
`
